import React from 'react';
import Widget from '../horizontalWidget2';
import { deviceWidth } from '@/utils/deviceWidth';

const CategoryWidget16 = (props) => {
  return (
    <Widget
      cardType={2}
      {...props}
      customScrollClass
      noArrows={deviceWidth <= 767 ? true : false}
    />
  );
};

export default CategoryWidget16;
